import { c as _c } from "react/compiler-runtime";
import RenderImage from "@/components/atoms/RenderImage";
import { RealEstateType } from "@/types/real-estate";
import Price from "@/components/atoms/Price";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useMapAtomPopupCluster } from "./useMapAtomPopupCluster";
import { useTranslations } from "next-intl";
type Props = {
  node: RealEstateType;
  isMobile?: boolean;
};
export default function MapAtomPopupCluster(t0) {
  const $ = _c(36);
  const {
    node,
    isMobile
  } = t0;
  const {
    data,
    imageSrc,
    realEstateType,
    handleOpenDialog
  } = useMapAtomPopupCluster(node);
  const tCluster = useTranslations("modules.search.map.cluster");
  if (!data) {
    return null;
  }
  const t1 = data?.title;
  let t2;
  if ($[0] !== imageSrc || $[1] !== t1) {
    t2 = <div className="relative h-32 aspect-square rounded-lg"><RenderImage src={imageSrc} alt={t1} fill={true} className="object-cover rounded-lg" data-sentry-element="RenderImage" data-sentry-source-file="MapAtomPopupCluster.tsx" /></div>;
    $[0] = imageSrc;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = data?.title;
  let t4;
  if ($[3] !== t3) {
    t4 = <h3 className="font-bold text-foreground line-clamp-2 text-sm">{t3}</h3>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = data.businessType;
  const t6 = data.salePrice;
  const t7 = data.lastBidPrice;
  const t8 = data.minPrice;
  const t9 = data.rentPrice;
  const t10 = isMobile ? "text-sm" : "";
  let t11;
  if ($[5] !== t10) {
    t11 = cn("text-muted-foreground", t10);
    $[5] = t10;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  if ($[7] !== data.businessType || $[8] !== data.lastBidPrice || $[9] !== data.minPrice || $[10] !== data.rentPrice || $[11] !== data.salePrice || $[12] !== t11) {
    t12 = <Price businessType={t5} salePrice={t6} lastBidPrice={t7} minPrice={t8} rentPrice={t9} className={t11} data-sentry-element="Price" data-sentry-source-file="MapAtomPopupCluster.tsx" />;
    $[7] = data.businessType;
    $[8] = data.lastBidPrice;
    $[9] = data.minPrice;
    $[10] = data.rentPrice;
    $[11] = data.salePrice;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== realEstateType) {
    t13 = realEstateType && <Badge size="sm" variant="muted" className="rounded-full cursor-default"><span className="capitalize">{realEstateType}</span></Badge>;
    $[14] = realEstateType;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t12 || $[17] !== t13) {
    t14 = <div className="flex items-center gap-2">{t12}{" "}{t13}</div>;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14 || $[20] !== t4) {
    t15 = <div className="flex flex-col gap-2">{t4}{t14}</div>;
    $[19] = t14;
    $[20] = t4;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== data.slug || $[23] !== handleOpenDialog) {
    t16 = () => handleOpenDialog(data.slug);
    $[22] = data.slug;
    $[23] = handleOpenDialog;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== tCluster) {
    t17 = tCluster("viewDetails");
    $[25] = tCluster;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16 || $[28] !== t17) {
    t18 = <div className=""><Button variant="simpleDark" onClick={t16} className="w-full" data-sentry-element="Button" data-sentry-source-file="MapAtomPopupCluster.tsx">{t17}</Button></div>;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t15 || $[31] !== t18) {
    t19 = <div className="flex flex-col justify-between gap-2 w-full">{t15}{t18}</div>;
    $[30] = t15;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t19 || $[34] !== t2) {
    t20 = <div className="flex gap-2" data-sentry-component="MapAtomPopupCluster" data-sentry-source-file="MapAtomPopupCluster.tsx">{t2}{t19}</div>;
    $[33] = t19;
    $[34] = t2;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  return t20;
}